<template>
  <SubNavCardVue :buttons="buttons" />
</template>

<script>
import SubNavCardVue from "../../components/cards/SubNavCard.vue";

export default {
  components: { SubNavCardVue },
  data() {
    return {
      buttons: [
        {
          label: "Crédits clients",
          icon: "bi bi-wallet2",
          route: "credits-index",
        },
        {
          label: "Crédits fournisseurs",
          icon: "bi bi-wallet-fill",
          route: "credits-suppliers-index",
        },
        {
          label: "Soldes créditeurs",
          icon: "bi bi-graph-up-arrow",
          route: "credits-balances",
        },
      ],
    };
  },
};
</script>
